// import {all,call,fork,put,takeEvery} from 'redux-saga/effects';
// import {firestore} from "../../helpers/Firebase";
// import {getNotificationDetail} from "./actions"
// import {NOTIFICATION_GET_DETAILS} from "../actions"
//
//
//
// const getNotificationData = async() => {
//     const announcement = await firestore.collection('Notifications').get();
//     const announcementData = announcement.docs;
//
//     const notificationArray =  announcementData.map((notification) => {
//         return {description:notification.data().description,timestamp: new Date(notification.data().timeStamp.seconds*1000)}
//     });
//
//
//     return notificationArray;
//
// };
//
//
// function* getNotification() {
//     const announcementData = yield call(getNotificationData);
//     yield put(getNotificationDetail(announcementData))
// }
//
//
//
// export function* watchGetNotification(){
//     yield takeEvery(NOTIFICATION_GET_DETAILS,getNotification);
// }
//
// export default function* rootSaga(){
//     yield all([
//         fork(watchGetNotification)
//     ]);
// }

import {all,call,fork,put,takeEvery} from "redux-saga/effects";
import {firestore} from "../../helpers/Firebase";
import {getNotificationDetail} from "./actions";
import {NOTIFICATION_GET_DETAILS} from "../actions";

const getNotificationData = async() => {
    const announcement = await firestore.collection('Notifications').orderBy('timeStamp',"desc").get()
    const announcementData = announcement.docs;
    const announcementArray = announcementData.map((newsannouncement) => {
        return {description:newsannouncement.data().description,timestamp: new Date(newsannouncement.data().timeStamp.seconds*1000)}
    });

    return announcementArray;
};

function* getNotification() {
    const announcementData = yield call(getNotificationData);
    yield put(getNotificationDetail(announcementData))
    console.log(announcementData);
}

export function* watchGetNotification() {
    yield takeEvery(NOTIFICATION_GET_DETAILS,getNotification);
}

export default function* rootSaga() {
    yield all([
        fork(watchGetNotification)
    ]);
}